//
// Imports
//

import * as FritterApiUtilities from "@donutteam/fritter-api-utilities";
import { z } from "zod";

//
// Types
//

// TODO: move this to a schema lib
const SortOrderSchema = z.number().int().min(-128).max(127);

export type RequestBody = z.infer<typeof RequestBodySchema>;

export const RequestBodySchema = z.object(
	{
		aboutShowcaseEnabled: z.boolean(),
		aboutShowcaseSortOrder: SortOrderSchema,

		badgesShowcaseEnabled: z.boolean(),
		badgesShowcaseSortOrder: SortOrderSchema,

		forumTopicsShowcaseEnabled: z.boolean(),
		forumTopicsShowcaseSortOrder: SortOrderSchema,

		forumTopicRepliesShowcaseEnabled: z.boolean(),
		forumTopicRepliesShowcaseSortOrder: SortOrderSchema,

		releasesShowcaseEnabled: z.boolean(),
		releasesShowcaseSortOrder: SortOrderSchema,
		releasesShowcaseReleaseCount: z.number().int().min(1).max(10),
		releasesShowcaseReleaseSortMode: z.number().int().min(0).max(4),
	});

export type ResponseBody = z.infer<typeof ResponseBodySchema>;

export const ResponseBodySchema = z.union(
	[
		FritterApiUtilities.SuccessResponseBodySchema,

		FritterApiUtilities.ErrorResponseBodySchema,
	]);